import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ServerTime } from './server-time.interface';

@Injectable({
  providedIn: 'root'
})
export class CloudflareTimeService implements ServerTime {
  private http = inject(HttpClient);

  private traceUrl = 'https://www.cloudflare.com/cdn-cgi/trace';

  public fetchServerTime(): Observable<number> {
    return this.http.get(this.traceUrl, { responseType: 'text' }).pipe(
      map((response) => {
        const serverTimeMatch = response.match(/(?<=\nts=)\d+\.\d+/);
        if (!serverTimeMatch) {
          throw new Error('Server time (ts) not found in the response.');
        }
        const serverTimeSeconds = parseFloat(serverTimeMatch[0]);
        return serverTimeSeconds * 1000;
      })
    );
  }
}
